import React from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Button, Spinner, Form, Col } from 'react-bootstrap';
import uniqBy from 'lodash.uniqby';

//Componentes
import { camposelect } from '../../../../components/forms/campos/campos';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

const ModalSelecionaEvento = (
    {
        selecionaevento, 
        edicaoevento, 
        handleModalEvento, 
        handleSelesionaEvento, 
        eventos, 
        pendingTasks, 
        handleEdicao}) => {
    return (
        <TelaModalLivre show={selecionaevento} handleCloseModal={() => handleModalEvento()}>
            <FinalForm
            onSubmit={handleSelesionaEvento}
            validate={values => {
                const errors = {};
                if(!values.evento){
                    errors.evento = 'Escolha um Evento';
                }
                return errors;
            }}
            render={({form, handleSubmit, pristine, submitting}) => {
                
                if(!eventos.length){
                    return null;
                }
                                
                let edicoes = uniqBy(eventos,'edicao');
                const edicoeslista = [
                    {edicao: 'Selecione'},
                    ...edicoes
                ]

                const eventoslista = [
                    {sigladoevento: 'Selecione', value: '', edicao: edicaoevento},
                    ...eventos
                ]

                console.log(pristine, eventos);
                return (
                    <form onSubmit={handleSubmit} method="post" >
                            <Form.Row>                                
                            {pendingTasks?
                            <Spinner animation="border"  />
                            :
                            null
                            }
                            <Form.Group as={Col} md="4" controlId="edicao">
                            <Field 
                            name="edicao" 
                            label="Selecione o Edição" 
                            component={camposelect}                                 
                            options={                                    
                                edicoeslista.map(evento => {
                                return ({
                                    "texto": evento.edicao, 
                                    "value": evento.edicao                                    
                                })
                            })}
                            />
                            <OnChange name="edicao">
                                {handleEdicao}
                            </OnChange>
                            </Form.Group>
                            <Form.Group as={Col} md="4" controlId="evento">
                            <Field 
                            name="evento" 
                            label="Selecione o Evento" 
                            component={camposelect} 
                            options={
                                eventoslista.map(evento => {
                                    if(parseInt(evento.edicao) !== parseInt(edicaoevento)){
                                        return {};
                                    }
                                    return ({
                                        "texto": evento.sigladoevento, "value": JSON.stringify(evento)
                                    })
                            })}
                            />    
                            </Form.Group>   
                        </Form.Row>                     
                        <Button type="submit">
                            Selecionar
                        </Button>
                    </form>
                )
            }}                
            />                
        </TelaModalLivre>
    )
}

export default ModalSelecionaEvento;